import type { UserRow } from "@/types/database";

/**
 * Org-user roles that share the organization console (dashboard, roster, MAPS, org studio)
 * with job-category scoping. Distinct from `orgadmin` (full org admin) and `employee` (roster-linked).
 *
 * `org_contact`: invited via superadmin portal-contact flow; same scoping mechanics as managers
 * but a separate role_type for flexible future policies and multi-role composition via `permissions`.
 */
export function isOrgConsoleContributor(
  user: Pick<UserRow, "user_type" | "role_type"> | null | undefined,
): boolean {
  return Boolean(
    user && user.user_type === "orguser" && (user.role_type === "manager" || user.role_type === "org_contact"),
  );
}
